export default {"src":"/_next/static/media/xMenu.ba273f31.svg","height":24,"width":24};